// extracted by mini-css-extract-plugin
export var blogs = "blog-module--blogs--mfLPf";
export var blogs_container = "blog-module--blogs_container--cVtCx";
export var main_title = "blog-module--main_title--w8JUe";
export var sub_title = "blog-module--sub_title--qvVDZ";
export var title = "blog-module--title--rVKQl";